import script from "./FullScreenPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullScreenPanel.vue?vue&type=script&setup=true&lang=ts"

import "./FullScreenPanel.vue?vue&type=style&index=0&id=dadc8e38&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dadc8e38"]])

export default __exports__